import useEffectOnce from "@/hooks/useEffectOnce";

/**
 * PHP is sick, and we need to help him clean some balagan he did
 * this will remove some element and style that bother our pure and clean react world
 */
export default function usePHPDoctor({ skipBRsRemoval, bodyClassesToRemove }: Props) {
  // INFO: this is for cleaning some of PHP balagans, we tried putting it in the tpl.php as a script
  // but it does not work, maybe php is injecting the <br /> only after page load
  useEffectOnce(() => {
    const bodyNode = document.querySelector("body");
    bodyClassesToRemove?.forEach((className) => {
      bodyNode?.classList.remove(className);
    })

    if (!skipBRsRemoval) {
      // NOTE: we have 2 <br /> at the end of the .mainContent so we remove them to look cleaner
      const allBrNodeInMainContent = document.querySelectorAll('.mainContent > br');
      allBrNodeInMainContent.forEach((el) => el.remove());

      // NOTE: we have 2 <br /> at the end of the .pageWrap so we remove them to look cleaner
      const allBrNodeInPageWrap = document.querySelectorAll('.pageWrap > br');
      allBrNodeInPageWrap.forEach((el) => el.remove());
    }
  });
  return;
}

interface Props {
  skipBRsRemoval?: boolean;
  /** remove a list of classes on the body that is clashing with us */
  bodyClassesToRemove?: string[];
}
